<template>
  <span class="form-label-with-tip">
    <span class="form-label-text">{{ label }}</span>
    <span class="form-label-tail">
      <el-tooltip v-if="tip" :content="tip" placement="top" effect="dark">
        <span class="label-term-tip">?</span>
      </el-tooltip>
      <span class="form-label-colon">:</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'FormLabelWithTip',
  props: {
    label: {
      type: String,
      required: true,
    },
    tip: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.form-label-with-tip {
  display: inline;
  line-height: 1.4;
  text-align: right;
  word-break: break-all;
  overflow-wrap: anywhere;
}

.form-label-tail {
  display: inline;
  white-space: nowrap;
}

.label-term-tip {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-left: 4px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  font-size: 12px;
  color: #c5c5c5;
  cursor: pointer;

  &:hover {
    background: #c5c5c5;
    color: #fff;
  }
}
</style>
